"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCalendarDays = exports.isSameMonth = exports.isSameDay = exports.isAfterDay = exports.isBeforeDay = exports.dateDiff = exports.getNextMonth = exports.getPreviousMonth = exports.getMonthFirstDay = exports.getMonthDays = exports.getDateArray = exports.monthNames = exports.isDate = exports.CALENDAR_DAYS_IN_WEEK = exports.CALENDAR_WEEKS_TO_DISPLAY = void 0;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var CALENDAR_WEEKS_TO_DISPLAY = 6;
exports.CALENDAR_WEEKS_TO_DISPLAY = CALENDAR_WEEKS_TO_DISPLAY;
var CALENDAR_DAYS_IN_WEEK = 7;
exports.CALENDAR_DAYS_IN_WEEK = CALENDAR_DAYS_IN_WEEK;

var isDate = function isDate(date) {
  var isObjectDate = Object.prototype.toString.call(date) === '[object Date]';
  var isValidDate = date && !Number.isNaN(+date);
  return isObjectDate && isValidDate;
};

exports.isDate = isDate;
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
exports.monthNames = monthNames;

var getDateArray = function getDateArray() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var year = date.getFullYear();
  var month = date.getMonth(); // from 0 = January

  var day = date.getDate();

  if (year === -1 || month === -1 || day === -1) {
    var e = new Error('Date passed in invalid');
    throw e;
  }

  return {
    year: year,
    month: month,
    day: day
  };
};

exports.getDateArray = getDateArray;

var getMonthDays = function getMonthDays() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var _getDateArray = getDateArray(date),
      year = _getDateArray.year,
      month = _getDateArray.month;

  return new Date(year, month + 1, 0).getDate();
};

exports.getMonthDays = getMonthDays;

var getMonthFirstDay = function getMonthFirstDay() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return new Date(new Date(+date).setDate(1)).getDay() + 1;
};

exports.getMonthFirstDay = getMonthFirstDay;

var getPreviousMonth = function getPreviousMonth() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var _getDateArray2 = getDateArray(date),
      year = _getDateArray2.year,
      month = _getDateArray2.month;

  return {
    month: month > 1 ? month - 1 : 12,
    year: month > 1 ? year : year - 1
  };
};

exports.getPreviousMonth = getPreviousMonth;

var getNextMonth = function getNextMonth() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

  var _getDateArray3 = getDateArray(date),
      year = _getDateArray3.year,
      month = _getDateArray3.month;

  return {
    month: month < 12 ? month + 1 : 1,
    year: month < 12 ? year : year + 1
  };
};

exports.getNextMonth = getNextMonth;

var dateDiff = function dateDiff(date1) {
  var date2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return isDate(date1) && isDate(date2) ? new Date(+date1).setHours(0, 0, 0, 0) - new Date(+date2).setHours(0, 0, 0, 0) : null;
};

exports.dateDiff = dateDiff;

var isBeforeDay = function isBeforeDay(date1, date2) {
  return +dateDiff(date1, date2) < 0;
};

exports.isBeforeDay = isBeforeDay;

var isAfterDay = function isAfterDay(date1, date2) {
  return +dateDiff(date1, date2) > 0;
};

exports.isAfterDay = isAfterDay;

var isSameDay = function isSameDay(date1, date2) {
  return dateDiff(date1, date2) === 0;
};

exports.isSameDay = isSameDay;

var isSameMonth = function isSameMonth(date1, date2) {
  return isDate(date1) && isDate(date2) ? new Date(date1.getFullYear(), date1.getMonth(), 1, 0, 0, 0).getTime() === new Date(date2.getFullYear(), date2.getMonth(), 1, 0, 0, 0).getTime() : false;
};

exports.isSameMonth = isSameMonth;

var getCalendarDays = function getCalendarDays() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var monthDays = getMonthDays(date);
  var monthFirstDay = getMonthFirstDay(date);

  var _getDateArray4 = getDateArray(date),
      year = _getDateArray4.year,
      month = _getDateArray4.month;

  var daysFromPrevMonth = monthFirstDay - 1;
  var daysFromNextMonth = CALENDAR_WEEKS_TO_DISPLAY * CALENDAR_DAYS_IN_WEEK - (daysFromPrevMonth + monthDays);

  if (daysFromNextMonth > 7) {
    daysFromNextMonth -= 7;
  }

  var _getPreviousMonth = getPreviousMonth(date),
      prevMonth = _getPreviousMonth.month,
      prevMonthYear = _getPreviousMonth.year;

  var _getNextMonth = getNextMonth(date),
      nextMonth = _getNextMonth.month,
      nextMonthYear = _getNextMonth.year;

  var prevMonthDays = getMonthDays(new Date(prevMonthYear, prevMonth, 1));

  var prevMonthDates = _toConsumableArray(new Array(daysFromPrevMonth)).map(function (n, index) {
    return {
      year: prevMonthYear,
      month: prevMonth,
      day: index + 1 + (prevMonthDays - daysFromPrevMonth)
    };
  });

  var thisMonthDates = _toConsumableArray(new Array(monthDays)).map(function (n, index) {
    return {
      year: year,
      month: month,
      day: index + 1
    };
  });

  var nextMonthDates = _toConsumableArray(new Array(daysFromNextMonth)).map(function (n, index) {
    return {
      year: nextMonthYear,
      month: nextMonth,
      day: index + 1
    };
  });

  return [].concat(_toConsumableArray(prevMonthDates), _toConsumableArray(thisMonthDates), _toConsumableArray(nextMonthDates));
};

exports.getCalendarDays = getCalendarDays;